import { render, staticRenderFns } from "./TurningOnBannerGroup.vue?vue&type=template&id=5f05a0f0"
import script from "./TurningOnBannerGroup.vue?vue&type=script&lang=ts"
export * from "./TurningOnBannerGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports